import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { NumOfVehiclesTypes, numberOfVehicles } from '../../../../domain/organization/Organization';
import { useUpdateOrganizationOnboarding } from '../../../../hooks/organization/useUpdateOrganizationOnboarding';
import Button from '../../../../react-components/Button';
import Text from '../../../../react-components/Text';
import eventsPanel from '../../../../services/events';
import { AnimatedStep } from '../AnimatedStep';
import { VehiclesStepper, isCompleted } from './VehiclesStepper';

interface NumVehiclesProps {
  onNextStep: () => void;
}

export const NumVehicles = ({ onNextStep }: NumVehiclesProps) => {
  const intl = useIntl();
  const { success, run: updateOrganization } = useUpdateOrganizationOnboarding();
  const [numVehicles, setNumVehicles] = useState<NumOfVehiclesTypes | undefined>(undefined);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        onNextStep();
        eventsPanel.onboardingPageView({ page: `numVehicles`, data: { numVehicles } });
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <AnimatedStep id="numVehiclesAnimatedContainer" isVisible={!success}>
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ padding: `20px`, maxWidth: `660px`, position: `relative` }}
      >
        <Grid item>
          <Text variant="h6" intlId="company.onboarding.num_of_vehicles.info" />
        </Grid>

        <VSpacer large />

        <Grid item container direction="column">
          <Grid item>
            <VehiclesStepper
              activeStepId={numVehicles}
              setActiveStep={(step: string) => setNumVehicles(step as NumOfVehiclesTypes)}
              steps={numberOfVehicles.map((id, _, array) => {
                return {
                  id,
                  label: intl.formatMessage({ id: `company.onboarding.num_of_vehicles.option.${id}` }),
                  completed: isCompleted({ currentStep: id, steps: array as string[], activeStep: numVehicles }),
                };
              })}
            />
          </Grid>
        </Grid>

        <Grid
          item
          container
          direction="row"
          wrap="nowrap"
          alignItems="center"
          justifyContent="center"
          style={{ position: `absolute`, bottom: `-60px` }}
        >
          {numVehicles !== undefined && (
            <Button
              intlId="company.onboarding.next"
              style={{
                width: `200px`,
                height: `32px`,
              }}
              onClick={() => {
                updateOrganization({
                  numOfVehicles: numVehicles,
                });
              }}
            />
          )}
        </Grid>
      </Grid>
    </AnimatedStep>
  );
};
